export interface DLZDTO {
  material_coverage_max_threshold: string | null;
  dlz_max_time_minutes: number | null;
  modified_at: string | null;
  modified_by: string;
}

export class DLZListDTO {
  constructor(public data: DLZDTO) {}
}
